import { useQuery } from '@tanstack/react-query';
import useFriends from '@/hooks/contacts/use-friends';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import type { GroupMember } from '@/models/group/group-info';

export default function useGroupMembers(groupId: number | null | undefined) {
  const { friends, isLoading: isFriendLoading } = useFriends();
  const { data, isLoading: isGroupInfoLoading } = useQuery({
    ...generateGroupInfoQueryOptions(groupId),
    select: (data) =>
      data?.Members?.reduce<Record<number, GroupMember>>((accu, member) => {
        const friend = friends[member.UserID];

        accu[member.UserID] = {
          ...member,
          RemarkName: friend?.RemarkName,
          DisplayName: friend?.RemarkName || member.GroupMemberName || member.UserNickName,
        };

        return accu;
      }, {}) ?? {},
  });

  return {
    members: data ?? {},
    bannedMembers: Object.values(data ?? {}).filter((m) => m.Status === 0) ?? [],
    isLoading: isGroupInfoLoading || isFriendLoading,
  } as const;
}
